import React, { useState } from 'react';
import {
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  Alert,
  Stack
} from '@mui/material';
import { useAuth } from '../../context/AuthContext';
// TODO: Intégrer avec l'API des utilisateurs côté serveur
// import { usersDB } from '../../db/database';

const ChangePassword = () => {
  const { currentUser } = useAuth();
  const [formData, setFormData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    setError('');
    setSuccess(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);
    setLoading(true);

    try {
      // Validation
      if (formData.newPassword !== formData.confirmPassword) {
        throw new Error('Les mots de passe ne correspondent pas');
      }

      if (formData.newPassword.length < 4) {
        throw new Error('Le mot de passe doit contenir au moins 4 caractères');
      }

      // TODO: Implémenter le changement de mot de passe via l'API
      console.log('Changement de mot de passe temporairement désactivé');
      alert('Fonctionnalité temporairement désactivée - migration en cours vers l\'API serveur');
      
      setSuccess(true);
      setFormData({
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
      });
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Paper sx={{ p: 3, maxWidth: 400, mx: 'auto', mt: 3 }}>
      <Typography variant="h6" gutterBottom>
        Modifier mon mot de passe
      </Typography>

      <form onSubmit={handleSubmit}>
        <Stack spacing={2}>
          <TextField
            name="currentPassword"
            label="Mot de passe actuel"
            type="password"
            value={formData.currentPassword}
            onChange={handleChange}
            fullWidth
            required
          />

          <TextField
            name="newPassword"
            label="Nouveau mot de passe"
            type="password"
            value={formData.newPassword}
            onChange={handleChange}
            fullWidth
            required
          />

          <TextField
            name="confirmPassword"
            label="Confirmer le nouveau mot de passe"
            type="password"
            value={formData.confirmPassword}
            onChange={handleChange}
            fullWidth
            required
          />

          {error && (
            <Alert severity="error">
              {error}
            </Alert>
          )}

          {success && (
            <Alert severity="success">
              {success}
            </Alert>
          )}

          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
          >
            Modifier le mot de passe
          </Button>
        </Stack>
      </form>
    </Paper>
  );
};

export default ChangePassword; 